
/* eslint-disable */
import toast from './src/main'
export default toast



// WEBPACK FOOTER //
// ./src/components/toast/index.js